import { render } from "./InputSwitch.vue?vue&type=template&id=5607a241"
import script from "./InputSwitch.vue?vue&type=script&lang=js"
export * from "./InputSwitch.vue?vue&type=script&lang=js"

import "./InputSwitch.vue?vue&type=style&index=0&id=5607a241&lang=css"
script.render = render

export default script